// Color Variables
export const color = {
  primaryColor: 'rgb(141, 208, 220)',
  primaryColorDark: 'rgb(97,176,191)',
  primaryColorLight: 'rgb(238, 251, 253)',
  secondaryColor: 'rgb(152, 169, 226)',
  secondaryColorDark: 'rgb(111,132,201)',
  secondaryColorLight: 'rgb(239, 243, 254)',
  complementColor: 'rgb(255, 207, 162)',
  complementColorDark: 'rgb(255,189,126)',
  complementColorLight: 'rgb(255, 247, 239)',
  fontColor: 'rgb(120, 120, 120)',
  fontColorLight: 'rgb(180, 180, 180)'
};

// Font Size Variables
